/**
 * @generated SignedSource<<a81f54056aa476f4771f2622af1d9a23>>
 * @relayHash 04ba37f7e52d10064ab666f7ddeec8cf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04ba37f7e52d10064ab666f7ddeec8cf

import type { ConcreteRequest } from 'relay-runtime';
export type ReportedContentClassifiers = "ABUSE" | "DUPLICATE" | "LOW_QUALITY" | "OFF_TOPIC" | "OUTDATED" | "RESOLVED" | "SPAM" | "%future added value";
export type MinimizeCommentInput = {
  classifier: ReportedContentClassifiers;
  clientMutationId?: string | null | undefined;
  isStaffActor?: boolean | null | undefined;
  reason?: string | null | undefined;
  subjectId: string;
};
export type minimizeCommentMutation$variables = {
  input: MinimizeCommentInput;
};
export type minimizeCommentMutation$data = {
  readonly minimizeComment: {
    readonly clientMutationId: string | null | undefined;
    readonly minimizedComment: {
      readonly isMinimized: boolean;
      readonly minimizedReason: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type minimizeCommentMutation$rawResponse = {
  readonly minimizeComment: {
    readonly clientMutationId: string | null | undefined;
    readonly minimizedComment: {
      readonly __typename: string;
      readonly __isNode?: string;
      readonly id?: string;
      readonly isMinimized: boolean;
      readonly minimizedReason: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type minimizeCommentMutation = {
  rawResponse: minimizeCommentMutation$rawResponse;
  response: minimizeCommentMutation$data;
  variables: minimizeCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMinimized",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimizedReason",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "minimizeCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "MinimizeCommentPayload",
        "kind": "LinkedField",
        "name": "minimizeComment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "minimizedComment",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "minimizeCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "MinimizeCommentPayload",
        "kind": "LinkedField",
        "name": "minimizeComment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "minimizedComment",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "04ba37f7e52d10064ab666f7ddeec8cf",
    "metadata": {},
    "name": "minimizeCommentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "32b76c06b9ed656b474cba5d4a6b96e4";

export default node;
